// components
import { styled, Box, BoxProps } from '@mui/material';

export const StyledToolbarSetContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isRightPositioned'
})<BoxProps & { isRightPositioned?: boolean }>(
  ({ theme, isRightPositioned }) => ({
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: isRightPositioned ? 'row-reverse' : 'column',
    gap: theme.spacing(4)
  })
);

export const StyledMainContentContainer = styled(Box)<BoxProps>(() => ({
  flex: 1,
  minWidth: 0
}));
